/**
 * Settings Navigator - Stack Navigator for Settings screens
 */

import { createStackNavigator } from '@react-navigation/stack';
import { ProfileScreen } from '../screens/settings/ProfileScreen';
import { ChangeEmailScreen } from '../screens/settings/ChangeEmailScreen';

export type SettingsNavigatorParamList = {
  UserProfile: undefined;
  ChangeEmail: undefined;
};

const Stack = createStackNavigator<SettingsNavigatorParamList>();

export function SettingsNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="UserProfile"
        component={ProfileScreen}
        options={{ title: 'My Profile' }}
      />
      <Stack.Screen
        name="ChangeEmail"
        component={ChangeEmailScreen}
        options={{ title: 'Change Email' }}
      />
    </Stack.Navigator>
  );
}
